export type RedirectTo = 'jira' | 'confluence';

const DEFAULT_REDIRECT_TO: RedirectTo = 'jira';

/**
 * Safely resolves a redirectTo value, defaulting to 'jira' when the value
 * is missing or not a recognised product.
 */
export function resolveRedirectTo(value: unknown): RedirectTo {
	if (value === 'jira' || value === 'confluence') {
		return value;
	}
	return DEFAULT_REDIRECT_TO;
}
